export const EXCMAGREEMENTCONSENT_CREATE_RESET = 'EXCMAGREEMENTCONSENT_CREATE_RESET'
export const EXCMAGREEMENTCONSENT_CREATE_SET_CREATED = 'EXCMAGREEMENTCONSENT_CREATE_SET_CREATED'
export const EXCMAGREEMENTCONSENT_CREATE_SET_ERROR = 'EXCMAGREEMENTCONSENT_CREATE_SET_ERROR'
export const EXCMAGREEMENTCONSENT_CREATE_SET_VIOLATIONS = 'EXCMAGREEMENTCONSENT_CREATE_SET_VIOLATIONS'
export const EXCMAGREEMENTCONSENT_CREATE_TOGGLE_LOADING = 'EXCMAGREEMENTCONSENT_CREATE_TOGGLE_LOADING'
